import {} from '@/scripts/constants/map';

const getShareLink = (type, link = window.location.href, params = {}) => {
  const { prefix = '//', postfix = '' } = params;

  const setup = {
    twitter: 'twitter.com/share?url=',
    facebook: 'facebook.com/sharer/sharer.php?u=',
    linkedin: 'linkedin.com/shareArticle?mini=true&url=',
    vk: 'vk.com/share.php?url=',
    reddit: 'reddit.com/submit?url=',
  };

  const sharer = setup[type];

  if (!type || !sharer) return link;

  const result = `${prefix}${sharer}${link}${postfix}`;

  return result;
};

/*  */
export { getShareLink };
